import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20elegant%20abstract%20background%20with%20soft%20rose%20gold%20and%20cream%20gradients%2C%20flowing%20organic%20curves%20suggesting%20intimacy%20and%20warmth%2C%20minimalist%20artistic%20composition%2C%20editorial%20luxury%20aesthetic%2C%20soft%20diffused%20lighting%2C%20no%20human%20figures%2C%20serene%20romantic%20atmosphere%2C%20high-end%20magazine%20quality&width=1600&height=620&seq=hero-oral-guide-01&orientation=landscape"
        alt="亲密指南 - 专业性健康教育平台"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-6">
          口交完全指南
        </h1>
        <p className="text-base md:text-lg text-white/85 max-w-2xl mx-auto leading-relaxed mb-8">
          以专业、科学和尊重的态度，提供全面的口交知识——从技巧入门到安全防护，
          从卫生护理到沟通艺术，帮助成年伴侣在知情同意的前提下提升亲密关系质量与性福体验。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/jiqiao"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-full font-medium text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            开始探索
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 border border-white/30 hover:border-white/60 text-white hover:bg-white/10 rounded-full font-medium text-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}